var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.998,
    height: 17.973,
    viewBox: "0 0 28.998 17.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    transform: "translate(2210.258 -563.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transport_Bike_1_copy_4",
    "data-name": "Transport_Bike_1 copy 4",
    transform: "translate(-2210.258 563.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37",
    "data-name": "Caminho 37",
    d: "M85.374,92.028a6.024,6.024,0,0,0-1.3.139l-1.206-3.573,2.181-.951a.685.685,0,0,0-.557-1.253L81.732,87.6a.689.689,0,0,0-.371.858l.6,1.763c-2.552.464-4.315,2.041-6.032,3.573-.626.557-1.23,1.09-1.856,1.578a6.138,6.138,0,1,0,.673,2.807,6.347,6.347,0,0,0-.186-1.485c.835-.6,1.554-1.253,2.273-1.879,1.694-1.485,3.271-2.923,5.568-3.271l.371,1.09a6.082,6.082,0,1,0,2.6-.6ZM73.38,98.152A4.744,4.744,0,1,1,68.624,93.4a4.707,4.707,0,0,1,4.292,2.737A8.619,8.619,0,0,1,68.6,97.456a.685.685,0,0,0,.046,1.369h.023a10.493,10.493,0,0,0,4.663-1.346A6.556,6.556,0,0,1,73.38,98.152Zm11.994,4.756a4.746,4.746,0,0,1-2.157-8.978l1.508,4.454a.7.7,0,0,0,.65.464.677.677,0,0,0,.209-.046.692.692,0,0,0,.441-.882l-1.508-4.454a5.144,5.144,0,0,1,.858-.07,4.756,4.756,0,0,1,0,9.511Z",
    transform: "translate(-62.5 -86.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M101.073,98.992h.557l.742,2.181a.7.7,0,0,0,.65.464,1.021,1.021,0,0,0,.232-.046.692.692,0,0,0,.441-.882l-.58-1.717H104.3a.7.7,0,0,0,.7-.7.684.684,0,0,0-.7-.7h-3.2a.7.7,0,0,0-.7.7A.679.679,0,0,0,101.073,98.992Z",
    transform: "translate(-91.608 -94.985)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeIcon);
export default __webpack_public_path__ + "static/media/bike-icon.1ee8145e6e65ea72b2f01b8cda0ef260.svg";
export { ForwardRef as ReactComponent };